import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';

const Contact = () => {
  return (
    <section
      id="contact"
      style={{
        padding: '60px 20px',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', marginBottom: '50px' }}
        >
          <div
            style={{
              display: 'inline-block',
              background: '#007bff',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '24px',
              padding: '12px 35px',
              borderRadius: '25px',
              textTransform: 'uppercase',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
          >
          Contact Us
          </div>
          <h2
            style={{
              color: 'Blue',
              fontSize: '22px',
              marginTop: '24px',
              fontWeight: 'bold'
            }}
          >
            Get in Touch
          </h2>
          <p style={{ color: 'black', fontSize: '22px', marginTop: '10px' }}>
            Connect with our team for queries and collaborations
          </p>
        </motion.div>

        {/* Two Columns */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '40px',
            justifyContent: 'center',
            alignItems: 'stretch' // ensures both columns have equal height
          }}
        >
          {/* Contact Info + Map */}
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1.0, ease: "easeOut" }}
            whileHover={{ y: -10 }}
            style={{
              flex: '1 1 500px',
              background: 'white',
              borderRadius: '20px',
              boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              padding: '40px',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between', // distributes content evenly
              height: '1240px' // match the right column height
            }}
          >
            <div>
              {/* Address */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '80px' }}>
                <FaMapMarkerAlt style={{ fontSize: '24px', color: '#007bff', marginRight: '15px' }} />
                <div>
                  <h4 style={{ fontWeight: 'bold', fontSize: '22px', margin: 0 }}>Address</h4>
                  <p style={{ fontSize: '18px', color: '#222', margin: 0 }}>
                    6-19-4/1, East Point Colony,<br />
                    Opposite Sai Baba Temple,<br />
                    Visakhapatnam, Andhra Pradesh, India
                  </p>
                </div>
              </div>

              {/* Email */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '80px' }}>
                <FaEnvelope style={{ fontSize: '24px', color: '#007bff', marginRight: '15px' }} />
                <div>
                  <h4 style={{ fontWeight: 'bold', fontSize: '22px', margin: 0 }}>Email</h4>
                  <a href="mailto:contact@sevenky.com" style={{ fontSize: '18px', color: '#222', margin: 0 }}>
                    contact@sevenky.com
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '80px' }}>
                <FaPhone style={{ fontSize: '24px', color: '#007bff', marginRight: '15px' }} />
                <div>
                  <h4 style={{ fontWeight: 'bold', fontSize: '22px', margin: 0 }}>Phone</h4>
                  <a href="tel:+918826375929" style={{ fontSize: '18px', color: '#222', margin: 0 }}>
                    +91-8826375929
                  </a>
                </div>
              </div>
            </div>

            {/* Google Map Embed */}
            <div style={{ borderRadius: '30px', overflow: 'hidden', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.398731171999!2d83.33451051483088!3d17.72584198787658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a394538ff16cabf%3A0xeaca15dca9c3e3a0!2sSEVENKY%20TECHNOLOGIES!5e0!3m2!1sen!2sin!4v1642456664489!5m2!1sen!2sin"
                width="100%"
                height="650"
                frameBorder="0"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
                title="Sevenky Location"
              ></iframe>
            </div>
          </motion.div>

          {/* Google Form Embed */}
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1.0, ease: "easeOut" }}
            whileHover={{ y: -10 }}
            style={{
              flex: '1 1 500px',
              background: 'white',
              borderRadius: '20px',
              boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
              padding: '15px',
              boxSizing: 'border-box',
              height: '1240px'
            }}
          >
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSd-e6wTSbPUrLGkdIP8yGB_h3zGbwlEsyhMFUqXV1_lNxqhRg/viewform?usp=sf_link"
              width="100%"
              height="1190"
              title="Contact Form"
            >
              Loading…
            </iframe>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
